import { api } from "./api";

export const followupsList = async (addUrl = ``) => {
  return api.get(`/followups?${addUrl}`);
};
export const AttendanceFollowupList = async (addUrl = ``) => {
  return api.get(`/students/long/absent/list?${addUrl}`);
};

export const followupAdd = async (data) => {
  return api.post(`/followup/add`, data);
};
